import { PartnerUI } from '@app/shared/modules/evc-api/models/partner-ui.interface';
import { Observable } from 'rxjs';
import { PartnerService } from '../../../modules/evc-quote/services/partner/partner.service';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { environment } from '@app/env';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public readonly environment = environment;
  public readonly partner$: Observable<PartnerUI>;

  constructor(private readonly partnerService: PartnerService, public title: Title) {
    this.partner$ = this.partnerService.partner$;
  }

  public handleMissingImage(event: Event): void {
    (event.target as HTMLImageElement).style.display = 'none';
  }
}
